var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppStore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98.154,
    height: 28.373,
    viewBox: "0 0 98.154 28.373",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    "data-name": "Group 67",
    transform: "translate(-2059.729 -2256.366)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M95.608,29.177H4.163A3.354,3.354,0,0,1,.809,25.823V4.16A3.354,3.354,0,0,1,4.163.8H95.608A3.355,3.355,0,0,1,98.963,4.16V25.823a3.355,3.355,0,0,1-3.355,3.355",
    transform: "translate(2058.921 2255.561)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M72.241,13.439l-.376-1.179c-.092-.291-.17-.616-.241-.893h-.014c-.069.277-.142.609-.225.893l-.369,1.179Zm-1.369.659-.412,1.356h-.9l1.534-4.782h1.113l1.553,4.782h-.935L72.39,14.1",
    transform: "translate(2021.412 2250.177)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M80.538,13.594l.561,1.75c.1.305.169.582.233.866h.021c.064-.284.142-.554.234-.866l.554-1.75h.914l-1.319,3.454h-.857l-1.285-3.454",
    transform: "translate(2015.937 2248.583)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M90.517,15.264c-.618-.007-1.207.121-1.207.646a.458.458,0,0,0,.5.5.715.715,0,0,0,.687-.476.547.547,0,0,0,.023-.192Zm.85.859a4.631,4.631,0,0,0,.057.829h-.788l-.062-.382h-.023a1.262,1.262,0,0,1-1.021.46A1.024,1.024,0,0,1,88.445,16c0-.866.772-1.312,2.048-1.3v-.057c0-.227-.091-.6-.7-.6a1.831,1.831,0,0,0-.93.256l-.17-.568a2.492,2.492,0,0,1,1.25-.3,1.294,1.294,0,0,1,1.425,1.461",
    transform: "translate(2011.108 2248.677)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M97.53,11.863H98.4v3.454H97.53Zm.431-.5a.493.493,0,1,1,.009,0",
    transform: "translate(2006.178 2250.314)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M102.27,15.139h.873V10.094h-.873Zm0,0",
    transform: "translate(2003.565 2250.493)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M108.509,15.264c-.618-.007-1.207.121-1.207.646a.458.458,0,0,0,.5.5.717.717,0,0,0,.688-.476.588.588,0,0,0,.021-.192Zm.85.859a4.62,4.62,0,0,0,.057.829h-.786l-.064-.382h-.021a1.268,1.268,0,0,1-1.022.46A1.024,1.024,0,0,1,106.438,16c0-.866.774-1.312,2.05-1.3v-.057c0-.227-.092-.6-.7-.6a1.82,1.82,0,0,0-.928.256l-.17-.568a2.485,2.485,0,0,1,1.248-.3,1.294,1.294,0,0,1,1.426,1.461",
    transform: "translate(2001.291 2248.677)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M116.422,13.711a.971.971,0,0,0,.021.206.8.8,0,0,0,.772.611c.547,0,.881-.433.881-1.134,0-.611-.291-1.108-.873-1.108a.81.81,0,0,0-.773.639,1.051,1.051,0,0,0-.028.227Zm-.873-3.618h.873v2.064h.014a1.247,1.247,0,0,1,1.106-.552c.845,0,1.446.7,1.44,1.752a1.654,1.654,0,0,1-1.567,1.859,1.187,1.187,0,0,1-1.092-.6h-.014l-.043.518h-.745c.014-.234.028-.618.028-.966",
    transform: "translate(1996.336 2250.493)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M125.4,15.139h.872V10.094H125.4Zm0,0",
    transform: "translate(1990.947 2250.493)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M131.965,14.861a.743.743,0,0,0-.715-.845.854.854,0,0,0-.8.845Zm-1.518.609a.94.94,0,0,0,1.065.895,2.779,2.779,0,0,0,.957-.156l.128.595a3.073,3.073,0,0,1-1.206.22,1.634,1.634,0,0,1-1.782-1.743,1.711,1.711,0,0,1,1.69-1.858,1.5,1.5,0,0,1,1.489,1.681,2.124,2.124,0,0,1-.028.367",
    transform: "translate(1988.649 2248.677)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M144.029,16.4c.495,0,.843-.483.843-1.184,0-.54-.241-1.164-.836-1.164-.618,0-.866.6-.866,1.179,0,.666.334,1.17.85,1.17Zm-.029.632a1.67,1.67,0,0,1-1.73-1.78,1.7,1.7,0,0,1,1.787-1.83,1.657,1.657,0,0,1,1.716,1.773,1.71,1.71,0,0,1-1.766,1.837",
    transform: "translate(1981.742 2248.677)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M152.206,14.528c0-.4-.012-.731-.026-1.03h.758l.042.518H153a1.269,1.269,0,0,1,1.108-.595c.6,0,1.226.389,1.226,1.482v2.048h-.873V15c0-.5-.184-.873-.658-.873a.733.733,0,0,0-.682.511.8.8,0,0,0-.043.277v2.034h-.873",
    transform: "translate(1976.335 2248.677)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M166.353,11.641v.886h.829v.653h-.829V14.7c0,.426.114.639.445.639a1.138,1.138,0,0,0,.341-.035l.014.659a1.867,1.867,0,0,1-.632.092,1,1,0,0,1-.751-.282,1.364,1.364,0,0,1-.277-.973V13.18H165v-.653h.49v-.644",
    transform: "translate(1969.339 2249.649)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M171.934,10.094h.873v2.057h.015a1.147,1.147,0,0,1,.433-.391,1.242,1.242,0,0,1,.6-.154c.589,0,1.205.389,1.205,1.5v2.036h-.872V13.195c0-.5-.184-.88-.667-.88a.728.728,0,0,0-.68.49.779.779,0,0,0-.036.263v2.072h-.873",
    transform: "translate(1965.558 2250.493)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M183.418,14.861a.743.743,0,0,0-.717-.845.853.853,0,0,0-.8.845Zm-1.518.609a.938.938,0,0,0,1.063.895,2.768,2.768,0,0,0,.957-.156l.13.595a3.076,3.076,0,0,1-1.207.22,1.633,1.633,0,0,1-1.78-1.743,1.71,1.71,0,0,1,1.688-1.858,1.5,1.5,0,0,1,1.49,1.681,2.117,2.117,0,0,1-.029.367",
    transform: "translate(1960.577 2248.677)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M33.285,24.863a4.25,4.25,0,0,1,2.027-3.571,4.358,4.358,0,0,0-3.435-1.857c-1.443-.151-2.844.866-3.579.866-.751,0-1.885-.85-3.1-.825a4.575,4.575,0,0,0-3.848,2.347c-1.661,2.881-.422,7.113,1.172,9.442.8,1.14,1.729,2.414,2.948,2.368,1.193-.05,1.638-.76,3.078-.76s1.846.76,3.09.731c1.28-.021,2.086-1.145,2.854-2.3a9.36,9.36,0,0,0,1.306-2.659,4.116,4.116,0,0,1-2.51-3.784",
    transform: "translate(2048.146 2245.405)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M40.026,12.48a4.185,4.185,0,0,0,.959-3A4.275,4.275,0,0,0,38.226,10.9a3.984,3.984,0,0,0-.983,2.892,3.52,3.52,0,0,0,2.783-1.315",
    transform: "translate(2039.055 2250.83)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M73.791,34.522l-.824-2.544q-.13-.389-.492-1.834h-.028c-.1.414-.252,1.026-.463,1.834l-.809,2.544Zm2.847,4.063H74.975l-.911-2.861H70.9l-.868,2.861H68.414l3.138-9.742h1.935",
    transform: "translate(2022.036 2240.263)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M94.549,38.132a2.892,2.892,0,0,0-.463-1.692,1.6,1.6,0,0,0-1.358-.694,1.62,1.62,0,0,0-1.047.383,1.8,1.8,0,0,0-.616,1.006,2.026,2.026,0,0,0-.071.474v1.172a1.878,1.878,0,0,0,.469,1.294,1.555,1.555,0,0,0,1.221.527,1.588,1.588,0,0,0,1.372-.68,2.97,2.97,0,0,0,.494-1.791m1.59-.059a3.99,3.99,0,0,1-.969,2.833,2.832,2.832,0,0,1-2.153.925,2.155,2.155,0,0,1-2-1h-.028v3.7H89.432V36.961q0-1.126-.057-2.313h1.372l.087,1.115h.03a2.774,2.774,0,0,1,4.443-.275,3.877,3.877,0,0,1,.832,2.586",
    transform: "translate(2010.6 2237.175)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M112.329,38.132a2.894,2.894,0,0,0-.463-1.692,1.6,1.6,0,0,0-1.358-.694,1.623,1.623,0,0,0-1.047.383,1.771,1.771,0,0,0-.613,1.006,1.96,1.96,0,0,0-.073.474v1.172a1.877,1.877,0,0,0,.467,1.294,1.557,1.557,0,0,0,1.223.527,1.592,1.592,0,0,0,1.372-.68,2.992,2.992,0,0,0,.492-1.791m1.589-.059a3.989,3.989,0,0,1-.967,2.833,2.828,2.828,0,0,1-2.153.925,2.159,2.159,0,0,1-2-1h-.026v3.7h-1.562V36.961q0-1.126-.057-2.313h1.372l.087,1.115h.03a2.774,2.774,0,0,1,4.443-.275,3.873,3.873,0,0,1,.829,2.586",
    transform: "translate(2000.899 2237.175)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M134.659,35.679a2.6,2.6,0,0,1-.866,2.024,3.838,3.838,0,0,1-2.652.852,4.659,4.659,0,0,1-2.528-.607l.362-1.3a4.291,4.291,0,0,0,2.258.62,2.134,2.134,0,0,0,1.374-.4,1.3,1.3,0,0,0,.49-1.065,1.359,1.359,0,0,0-.4-1,3.8,3.8,0,0,0-1.346-.753q-2.559-.956-2.558-2.794a2.472,2.472,0,0,1,.9-1.969,3.539,3.539,0,0,1,2.384-.769,4.742,4.742,0,0,1,2.212.463l-.391,1.273a3.838,3.838,0,0,0-1.864-.449,1.881,1.881,0,0,0-1.285.4,1.162,1.162,0,0,0-.391.882,1.186,1.186,0,0,0,.448.953,5.084,5.084,0,0,0,1.416.753,4.8,4.8,0,0,1,1.849,1.184,2.487,2.487,0,0,1,.593,1.692",
    transform: "translate(1989.193 2240.438)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M148.133,33.893h-1.72V37.3q0,1.3.912,1.3a2.808,2.808,0,0,0,.693-.071l.042,1.184a3.464,3.464,0,0,1-1.212.174,1.878,1.878,0,0,1-1.446-.563,2.771,2.771,0,0,1-.52-1.894V33.893h-1.026V32.721h1.026V31.436l1.532-.463v1.748h1.72",
    transform: "translate(1980.877 2239.102)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M160.474,38.153a3.164,3.164,0,0,0-.421-1.667,1.538,1.538,0,0,0-1.4-.841,1.564,1.564,0,0,0-1.431.841,3.226,3.226,0,0,0-.417,1.7,3.152,3.152,0,0,0,.417,1.665,1.575,1.575,0,0,0,1.418.841,1.558,1.558,0,0,0,1.4-.856,3.154,3.154,0,0,0,.433-1.681m1.619-.05a3.847,3.847,0,0,1-.925,2.659,3.3,3.3,0,0,1-2.572,1.069,3.145,3.145,0,0,1-2.466-1.026,3.739,3.739,0,0,1-.916-2.586,3.809,3.809,0,0,1,.946-2.673A3.268,3.268,0,0,1,158.71,34.5,3.211,3.211,0,0,1,161.2,35.53a3.707,3.707,0,0,1,.9,2.574",
    transform: "translate(1974.679 2237.175)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M177,36.022a2.716,2.716,0,0,0-.492-.043,1.478,1.478,0,0,0-1.273.621,2.347,2.347,0,0,0-.389,1.386v3.687h-1.56l.012-4.812q0-1.217-.057-2.214h1.36l.057,1.346h.041a2.413,2.413,0,0,1,.781-1.113,1.9,1.9,0,0,1,1.129-.376,2.582,2.582,0,0,1,.391.028",
    transform: "translate(1964.842 2237.175)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M187.891,37.407a2.126,2.126,0,0,0-.3-1.2,1.368,1.368,0,0,0-1.245-.651,1.484,1.484,0,0,0-1.242.637,2.307,2.307,0,0,0-.46,1.214Zm1.487.4a3.812,3.812,0,0,1-.055.708h-4.681a2.028,2.028,0,0,0,.678,1.59,2.315,2.315,0,0,0,1.532.49,5.179,5.179,0,0,0,1.894-.332l.245,1.085a5.908,5.908,0,0,1-2.358.435,3.4,3.4,0,0,1-2.565-.964,3.55,3.55,0,0,1-.932-2.579A4.016,4.016,0,0,1,184,35.6a2.986,2.986,0,0,1,2.455-1.127,2.617,2.617,0,0,1,2.3,1.127,3.79,3.79,0,0,1,.618,2.212",
    transform: "translate(1959.445 2237.192)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStore);
export default __webpack_public_path__ + "static/media/app-store.5ba361013779bd5940dd51f221ae2aab.svg";
export { ForwardRef as ReactComponent };